module.exports = __webpack_public_path__ + "img/8.7bc93522.png";